import { render, staticRenderFns } from "./Product_add.vue?vue&type=template&id=6b4a33f8&"
import script from "./Product_add.vue?vue&type=script&lang=js&"
export * from "./Product_add.vue?vue&type=script&lang=js&"
import style0 from "./Product_add.vue?vue&type=style&index=0&id=6b4a33f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports